import React from 'react';
import { Typography, Box, Button, Paper } from '@mui/material';
import ReviewFetcher from '../components/admin/ReviewFetcher';
import { RefreshCw } from 'lucide-react';

const AdminReviewsPage = () => {
  return (
    <Box sx={{ 
      bgcolor: 'background.default',
      minHeight: '100vh',
      py: 3,
      px: 3
    }}>
      <Paper sx={{ 
        p: 3, 
        mb: 3,
        borderRadius: 1,
        boxShadow: 1
      }}>
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center'
        }}>
          <Typography variant="h5" component="h1" sx={{ fontWeight: 'medium' }}>
            Reviews Management
          </Typography>
          <Button 
            variant="contained" 
            color="primary"
            startIcon={<RefreshCw size={18} />}
            onClick={() => window.location.reload()}
          >
            Refresh Data
          </Button>
        </Box>
      </Paper>
      
      <ReviewFetcher />
      
      {/* Additional review management components can be added here */}
    </Box>
  );
};

export default AdminReviewsPage;
